import React, {useState, useRef, useEffect} from 'react';
import './App.css';
import marked from 'marked';

const sendToApp = (message) => {
  console.log("sendToApp message:", message);
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage("href:" + message);
  }
  // Android
  if (window.android) {
    window.android.postMessage("href:" + message);
  }
};

const ChatMessageHistroy = ({ message, prevUpdatedAt }) => {
  const [bShowTime, setShowTime] = useState(false);
  const [strTime, setStrTime] = useState('');
  const textareaRefUser = useRef(null);
  const textareaRefBot = useRef(null);

  // 获取文本的宽度
  const getTextWidth = (textareCom) => {
    const text = textareCom.value
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = getComputedStyle(document.body).fontSize + ' Arial';
    let width = context.measureText(text).width * 1.8;
    let screenWidth = window.innerWidth - 50;
    textareCom.style.width = '100%';
    textareCom.style.height = 'auto';
    textareCom.style.height = textareCom.scrollHeight + "px"; // 让高度适应内容
  };

  const autoResize = () => {
    if(textareaRefUser.current){
      getTextWidth(textareaRefUser.current);
    }
    if(textareaRefBot.current){
      // 重置高度以便重新计算
      textareaRefBot.current.style.height = 'auto';
      // 设置高度为滚动高度
      textareaRefBot.current.style.height = `${textareaRefBot.current.scrollHeight}px`;
    }
  };

  const countTime = () =>{
    // 两个 updatedAt 时间
    const updatedAt1 = message.createdAt;
    const updatedAt2 = prevUpdatedAt;
    if(prevUpdatedAt === null || prevUpdatedAt === undefined){
      setShowTime(true);
    }

    // 将字符串转换为 Date 对象
    const date = new Date(updatedAt1);
    const date2 = new Date(updatedAt2);
    // 获取年、月、日、小时和分钟
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // 格式化为 年-月-日 时:分
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    setStrTime(formattedDate)
    // 计算时间差（以毫秒为单位）
    const timeDiff = Math.abs(date2 - date);

    // 将毫秒转换为天、小时、分钟和秒
    const diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const diffSeconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    if(diffMinutes > 4){
      setShowTime(true);
    }
  }

  useEffect(() => {
    autoResize();
    
    setTimeout(() => {
      countTime();
    }, 1000);

  }, []);

  const handleInputChange = (e) => {
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
  };

  function compressBlankLines(markdown) {
    return markdown.replace(/\n{3,}/g, '\n\n');
  }

 function handleMDClick(e) {
    const anchor = e.target.closest('a');
    if (anchor) {
      e.preventDefault();
      sendToApp(anchor.href);
    }
  }

  return (
    <div>
        {bShowTime && 
          <div className='container-center'>
            {strTime}
          </div>
        }

        <div className='container-right'>
          <div className='chat-message-user' value={message.question}
          readOnly={true}
          onChange={handleInputChange}
          ref={textareaRefUser}
          >
            {message.question}
          </div>
          <label className='UserHeadLabel'>
          </label>
        </div>

        <div className='container-left'>
          <label className='AIHeadLabel'>
          </label>
          <div className='chat-message-bot'  dangerouslySetInnerHTML={{ __html: marked(compressBlankLines(message.answer)) }}
              readOnly={true}
              ref={textareaRefBot}
              onClick={handleMDClick}
            >
          </div> 
        </div>

    </div>


  );
};

export default ChatMessageHistroy;
